import React from 'react';
import {
    ClearStorage,
    Crossroad3Command,
    Crossroad4Command,
    TurnCommand,
    CustomEndCommand,
    EmptyPuzzleCommand,
    EndCommand,
    GoStraightCommand,
    GoLeftCommand,
    GoRightCommand,
    PauseCommand,
    SlowCommand,
    StartCommand,
    TurboCommand,
    TornadoSpin,
    UTurnCommand,
    LineJumpStraight,
    GetOzobotStorage,
    LineJumpLeft,
    LineJumpRight,
    StraightCommand,
    RedPuzzle,
    GreenPuzzle,
    BluePuzzle,
    DefaultPuzzle,
    ZigzagOrBackWalkCommand,
    StartStopStoperCommand,
    CountIntersectionsCommand,
    CountTurnsCommand,
    CountColorPathsCommand,
} from "./OzobotCommands";
import {OzobotImage} from "./OzobotStyles";

export default function Ozobot({id, top, left, margin, marginX, scale, angle, onDragStart = () => {}, onDragEnd = () => {}, color}) {
    const width = 80;
    const height = 80;

    let style = {
        top: (top - width / 2) * scale,
        left: (left - height / 2) * scale,
        transform: 'rotate(' + (parseFloat(angle) + 90) + 'deg)',
        width: width * scale,
        height: height * scale,
    };

    return <OzobotImage
        id={id}
        style={style}
        draggable
        margin={margin * scale}
        marginX={marginX * scale}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        color={color}
    />;
}

export const GetStorage = GetOzobotStorage;
export const ClearOzobotStorage = ClearStorage;

export const RunPuzzleCommand = async (currentPuzzle, paramsReference, rotateLeft, rotateRight, sleep, rotateLeft45, rotateRight45,
                                       changeColor, moveMargin, zigzag, rotateToDirection) => {
    const forward = direction => direction;

    await RedPuzzle(currentPuzzle, changeColor, moveMargin, sleep, paramsReference, rotateLeft45, rotateRight45);
    await GreenPuzzle(currentPuzzle, changeColor, moveMargin, sleep, paramsReference, rotateLeft45, rotateRight45);
    await BluePuzzle(currentPuzzle, changeColor, moveMargin, sleep, paramsReference, rotateLeft45, rotateRight45);
    await DefaultPuzzle(currentPuzzle, changeColor);
    await TurnCommand(currentPuzzle, paramsReference, rotateRight45, rotateLeft45, sleep);
    await StartCommand(currentPuzzle, paramsReference, rotateRight, rotateLeft, sleep);
    await StraightCommand(currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight);

    if (localStorage.getItem('is_first_puzzle') === '1') {
        return;
    }

    await Crossroad4Command(currentPuzzle, paramsReference, forward, rotateLeft, rotateRight, moveMargin, sleep, changeColor,
        rotateLeft45, rotateRight45);
    await Crossroad3Command(currentPuzzle, paramsReference, forward, rotateLeft, rotateRight, moveMargin, sleep, changeColor,
        rotateLeft45, rotateRight45);
    await TurboCommand(currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight);
    await SlowCommand(currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight);
    await PauseCommand(currentPuzzle, sleep, changeColor, paramsReference, rotateLeft, rotateRight);
    await UTurnCommand(currentPuzzle, paramsReference, rotateRight, rotateLeft, changeColor);
    await GoStraightCommand(currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight);
    await GoRightCommand(currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight);
    await GoLeftCommand(currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight);
    await EndCommand(currentPuzzle, paramsReference, rotateRight45, rotateLeft45, sleep, changeColor, moveMargin);
    await CustomEndCommand(currentPuzzle, paramsReference, rotateRight, rotateLeft, sleep, changeColor);
    EmptyPuzzleCommand(currentPuzzle);
    await TornadoSpin(currentPuzzle, paramsReference, rotateRight45, sleep, changeColor, rotateLeft, rotateRight);
    await LineJumpStraight(currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight);
    await LineJumpLeft(currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight);
    await LineJumpRight(currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight);
    await ZigzagOrBackWalkCommand(currentPuzzle, zigzag, paramsReference, changeColor, rotateLeft, rotateRight, rotateToDirection)
    await StartStopStoperCommand(currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight, sleep);
    await CountIntersectionsCommand(currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight);
    await CountTurnsCommand(currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight);
    await CountColorPathsCommand(currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight);
};



// WEBPACK FOOTER //
// ./src/Simulator/Ozobot/Ozobot.js